angular.module("leanlaw").controller("tutorialModalController", ["$scope", "close", function ($scope, close) {
  $scope.close = close;
}]);